/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ExamExamitemidPreviewQueryResponse,
  GetApiV1ExamExamitemidPreviewPathParams,
  GetApiV1ExamExamitemidPreview401,
  GetApiV1ExamExamitemidPreview404,
  GetApiV1ExamExamitemidPreview500,
} from "../../types/examQuestionLibraryController/GetApiV1ExamExamitemidPreview.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ExamExamitemidPreview } from "../../clients/examQuestionLibraryController/getApiV1ExamExamitemidPreview.ts";

export const getApiV1ExamExamitemidPreviewQueryKey = (
  examItemId: GetApiV1ExamExamitemidPreviewPathParams["examItemId"],
) =>
  [
    {
      url: "/api/v1/exam/:examItemId/preview",
      params: { examItemId: examItemId },
    },
  ] as const;

export type GetApiV1ExamExamitemidPreviewQueryKey = ReturnType<
  typeof getApiV1ExamExamitemidPreviewQueryKey
>;

export function getApiV1ExamExamitemidPreviewQueryOptions(
  examItemId: GetApiV1ExamExamitemidPreviewPathParams["examItemId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ExamExamitemidPreviewQueryKey(examItemId);
  return queryOptions<
    GetApiV1ExamExamitemidPreviewQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamExamitemidPreview401
      | GetApiV1ExamExamitemidPreview404
      | GetApiV1ExamExamitemidPreview500
    >,
    GetApiV1ExamExamitemidPreviewQueryResponse,
    typeof queryKey
  >({
    enabled: !!examItemId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ExamExamitemidPreview(examItemId, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna os dados de pré-visualização de uma questão da biblioteca, incluindo tipo do componente, rótulo, informações e, quando aplicável, as opções da lista de respostas. **(Requer Authorization para autenticação)**
 * @summary Pré-visualizar questão da biblioteca (Requer Authorization para autenticação)
 * {@link /api/v1/exam/:examItemId/preview}
 */
export function useGetApiV1ExamExamitemidPreview<
  TData = GetApiV1ExamExamitemidPreviewQueryResponse,
  TQueryData = GetApiV1ExamExamitemidPreviewQueryResponse,
  TQueryKey extends QueryKey = GetApiV1ExamExamitemidPreviewQueryKey,
>(
  examItemId: GetApiV1ExamExamitemidPreviewPathParams["examItemId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ExamExamitemidPreviewQueryResponse,
        ResponseErrorConfig<
          | GetApiV1ExamExamitemidPreview401
          | GetApiV1ExamExamitemidPreview404
          | GetApiV1ExamExamitemidPreview500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1ExamExamitemidPreviewQueryKey(examItemId);

  const query = useQuery(
    {
      ...getApiV1ExamExamitemidPreviewQueryOptions(examItemId, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1ExamExamitemidPreview401
      | GetApiV1ExamExamitemidPreview404
      | GetApiV1ExamExamitemidPreview500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
